import React from 'react';
import {BaseMixin, ElementaryMixin, SectionMixin, ColorSchemaMixin, NestingLevelMixin} from '../common/common.js';
import Environment from '../environment/environment.js';
import Section from './section.js';

import './newspaper.less';

export const Newspaper = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    SectionMixin,
    ColorSchemaMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Newspaper',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'box'),
    classNames: {
      main: 'uu5-bricks-newspaper uu5-common-text',
      //bg: 'uu5-common-bg',
      columns: 'uu5-common-newspaper-layout-'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    columnsCount: React.PropTypes.oneOf([
      1, 2, 3, 4, 5, 6
    ]),
    //background: React.PropTypes.bool
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      columnsCount: 2,
      //background: false
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getMainProps: function () {
    var mainProps = this.getMainPropsToPass();
    mainProps.className += ' ' + this.getClassName().columns + this.props.columnsCount;
    //this.props.background && (mainProps.className += ' ' + this.getClassName().bg);
    return mainProps;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
          <Section {...this._getMainProps()}>
            {this.props.children && React.Children.toArray(this.props.children)}
          </Section>
        ) : null
    );
  }
  //@@viewOff:render
});

export default Newspaper;



// WEBPACK FOOTER //
// ./bricks/newspaper.js